import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "banner-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "nav-container" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import DarkRangerBanner from '@/assets/imgs/dark-ranger-banner.webp';
import DarkRanger from '@/assets/imgs/dark-ranger.webp';
import { NavLink } from './TopNavbar.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNavbar',
  setup(__props) {

const isMobile = ref(false);

function checkWidth() {
  isMobile.value = window.innerWidth < 1000;
}

onMounted(() => {
  checkWidth();
  window.addEventListener('resize', checkWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkWidth);
});

const navLinks = computed<NavLink[]>(() => [
  { label: 'Home', name: 'dr-university-home' },
  { label: 'Matchups', name: 'dr-university-matchups' },
  { label: 'Founders', name: 'dr-university-founders' },
  { label: 'Players', name: 'dr-university-players' },
]);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: isMobile.value ? _unref(DarkRanger) : _unref(DarkRangerBanner),
      alt: "Banner",
      class: "banner-img"
    }, null, 8, _hoisted_2),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
        return (_openBlock(), _createBlock(_component_RouterLink, {
          key: link.name,
          to: { name: link.name },
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.label), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}
}

})